// Shim de `firebase/app` — notre serveur Express remplace Firebase.
// initializeApp/getApp/getApps renvoient de simples objets-poignées ; aucune
// connexion Google n'est établie. La config Firebase éventuelle est ignorée.

export function initializeApp(config) {
  return { __ep: true, options: config || {} };
}
export function getApp() {
  return { __ep: true };
}
export function getApps() {
  return [{ __ep: true }];
}

export default { initializeApp, getApp, getApps };
